import API from "./api";

export const isLoggedIn = () => {
    const storedUser = window.localStorage.getItem('user');

    return storedUser !== null
};

export const handleLogout = async (event) => {
    event.preventDefault();
    await API.get('/api/auth/logout');
    localStorage.removeItem('rotaAtual')
    localStorage.removeItem('user')
    document.location.href = '/'
};